import { render, staticRenderFns } from "./grccms_bloglist.vue?vue&type=template&id=00b10d62&scoped=true&"
import script from "./grccms_bloglist.vue?vue&type=script&lang=js&"
export * from "./grccms_bloglist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b10d62",
  null
  
)

export default component.exports